import { Component, OnInit, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { formatNumber } from '../../../../shared/utils/common';

@Component({
  selector: 'app-fans-gender',
  templateUrl: './fans-gender.component.html',
  styleUrls: ['./fans-gender.component.less'],
})
export class FansGenderComponent implements OnInit, OnChanges {
  constructor(private el: ElementRef) {}

static NAME = 'icc-msg-social-fans-gender';

  // 数据源
  @Input() data: Array<{
    value: number; // 数量
    item: string; // 性别名称
  }>;

  pieData: Array<{
    name: string; // 性别名称
    value: string; // 数量
    ratio: string; // 比例
    floorPx: number; // 底板向左移动的px值
  }>;

  maleData: any;
  femaleData: any;

  ngOnInit() {
    this.pieData = this.formatPieData(this.data);
    this.getMaleAndFemaleData(this.pieData);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.pieData = this.formatPieData(this.data);
    this.getMaleAndFemaleData(this.pieData);
  }

  // 数据处理
  formatPieData(data) {
    if (data && data.length > 0) {
      const result = [];
      let total = 0;
      data.forEach((item: any) => {
        total += item.value;
      });
      data.forEach((item: any) => {
        const temp: any = {};
        temp.name = item.item;
        temp.value = formatNumber(item.value);
        const radioBefore = Number((item.value / total).toFixed(2)) * 100;
        temp.floorPx = Math.floor(radioBefore) * 4;
        temp.ratio = radioBefore.toFixed(0) + '%';
        result.push(temp);
      });
      return result;
    }
  }

  // 取出男女各自数据
  getMaleAndFemaleData(pieData) {
    if (pieData && pieData.length > 0) {
      for (let item of pieData) {
        if (item.name === '1') {
          this.maleData = item;
        }
        if (item.name === '2') {
          this.femaleData = item;
        }
      }
    }
  }
}
